import { EnvelopError } from '@/types/api'

import { ContactUsFormValues } from '../types'

type ContactUsFieldErrors = Partial<{ [key in keyof ContactUsFormValues]: string }> | null

export const generateErrorMessage = (error?: EnvelopError): ContactUsFieldErrors => {
    if (!error) return null

    const errors: ContactUsFieldErrors = {}

    switch (error.code) {
        case 'invalid.Name':
        case 'invalid_input_name':
            errors.fullName = 'نام و نام‌ خانوادگی وارد شده نامعتبر است.'
            break
        case 'invalid.MobileNumber':
        case 'invalid_input_mobile_number':
            errors.phone = 'شماره موبایل وارد شده نامعتبر است.'
            break
        case 'invalid_input_email':
            errors.emailAddress = 'ایمیل وارد شده نامعتبر است.'
            break
        case 'invalid_input_message':
            errors.message = 'متن پیام وارد شده نامعتبر است.'
            break
    }

    return errors
}
